(() => {
  function initWearseHeader() {
  const desktopHoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');

  function setDetailsOpen(details, isOpen) {
    details.toggleAttribute('open', isOpen);
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(isOpen));
  }

  document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
    const details = menu.querySelector(':scope > details');
    const summary = details?.querySelector(':scope > summary');
    if (!details || !summary) return;

    let pointerClick = false;

    summary.addEventListener('pointerdown', (event) => {
      pointerClick = event.pointerType !== 'touch';
    });

    summary.addEventListener('click', (event) => {
      if (desktopHoverQuery.matches && pointerClick) {
        event.preventDefault();
        setDetailsOpen(details, true);
      }
      pointerClick = false;
    });

    menu.addEventListener('pointerenter', () => {
      if (desktopHoverQuery.matches) setDetailsOpen(details, true);
    });

    menu.addEventListener('pointerleave', () => {
      if (desktopHoverQuery.matches && !menu.contains(document.activeElement)) {
        setDetailsOpen(details, false);
      }
    });

    menu.addEventListener('focusin', () => {
      if (desktopHoverQuery.matches) setDetailsOpen(details, true);
    });

    menu.addEventListener('focusout', (event) => {
      if (desktopHoverQuery.matches && !menu.contains(event.relatedTarget)) {
        setDetailsOpen(details, false);
      }
    });

    menu.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setDetailsOpen(details, false);
      summary.focus();
    });
  });

  const details = document.querySelector('#Details-menu-drawer-container');
  if (!details || details.dataset.wearseInitialized) return;
  details.dataset.wearseInitialized = 'true';
  const controller = new AbortController();
  const listen = (node, type, fn, capture = false) => node?.addEventListener(type, fn, { signal: controller.signal, capture });
  const summary = details.querySelector(':scope > summary');
  const drawer = details.querySelector('#menu-drawer');
  const modal = document.querySelector('#WearseMobileSearchModal');
  let closingTimer;
  const duration = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 240;
  const release = () => {
    document.body.classList.remove('wearse-menu-open', 'wearse-search-open');
    details.classList.remove('menu-opening', 'wearse-drawer-closing');
    details.open = false;
    summary.setAttribute('aria-expanded', 'false');
  };
  function closeDrawer(after) {
    clearTimeout(closingTimer);
    details.classList.add('wearse-drawer-closing');
    details.classList.remove('menu-opening');
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    closingTimer = setTimeout(() => {
      release();
      summary.focus({ preventScroll: true });
      if (typeof after === 'function') after();
    }, duration());
  }
  function openDrawer() {
    clearTimeout(closingTimer);
    details.classList.remove('wearse-drawer-closing');
    details.open = true;
    document.body.classList.add('wearse-menu-open');
    summary.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => {
      details.classList.add('menu-opening');
      if (typeof trapFocus === 'function') trapFocus(drawer, drawer.querySelector('[data-wearse-menu-close]'));
    });
  }
  function closeSearch() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('wearse-search-open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(summary);
  }
  function openSearch() {
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('wearse-search-open');
    if (typeof trapFocus === 'function') trapFocus(modal.querySelector('[role="dialog"]'), modal.querySelector('input[type="search"]'));
  }
  // Capture prevents Dawn's generic drawer button handlers from also changing this drawer.
  listen(details, 'click', (event) => {
    if (event.target.closest('summary') === summary) {
      event.preventDefault(); event.stopImmediatePropagation();
      details.open ? closeDrawer() : openDrawer();
    } else if (event.target.closest('[data-wearse-menu-close]')) {
      event.preventDefault(); event.stopImmediatePropagation(); closeDrawer();
    } else if (event.target.closest('[data-wearse-menu-search]')) {
      event.preventDefault(); event.stopImmediatePropagation(); closeDrawer(openSearch);
    } else if (event.target.closest('a[href]')) closeDrawer();
  }, true);
  listen(document, 'keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (modal && !modal.hidden) { event.preventDefault(); closeSearch(); }
    else if (details.open) { event.preventDefault(); closeDrawer(); }
  }, true);
  listen(details, 'keyup', (event) => {
    if (event.key === 'Escape') event.stopImmediatePropagation();
  }, true);
  modal?.querySelectorAll('[data-wearse-mobile-search-close]').forEach(button => listen(button, 'click', closeSearch));
  listen(window, 'resize', () => {
    if (innerWidth >= 990) { if (details.open) closeDrawer(); if (modal && !modal.hidden) closeSearch(); }
  });
  listen(document, 'shopify:section:unload', (event) => {
    if (!event.target.contains(details)) return;
    clearTimeout(closingTimer);
    if (typeof removeTrapFocus === 'function' && (details.open || (modal && !modal.hidden))) removeTrapFocus();
    release(); controller.abort();
  });

  }

  document.addEventListener('shopify:section:load', initWearseHeader);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWearseHeader, { once: true });
  } else {
    initWearseHeader();
  }
})();
